export default __webpack_public_path__ + "static/media/bmi_image.4d605fbb.png";